import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GlobalHeaderLibraryModule } from '@cudirect/shared-ui-library';
import { LenderService } from '@shared/service/lender/lender.service';
import { RuntimeConfigService } from '@app/service/runtime-config.service';
import { HeaderMenuComponent } from '../../components/header-menu/header-menu.component';
import { LenderConfiguration } from '@shared/model/lender-config.model';

@Component({
  selector: 'dx-admin-header',
  imports: [
    CommonModule, 
    RouterModule, 
    GlobalHeaderLibraryModule, 
    HeaderMenuComponent
  ],
  templateUrl: './admin-header.component.html',
  styleUrl: './admin-header.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AdminHeaderComponent implements OnInit {
  @Input() logoHref = '/admin/dashboard';
  @Input() userName: string;
  @Output() logout = new EventEmitter<void>();
  @Output() refreshOSData = new EventEmitter<void>();

  public lenderConfig: LenderConfiguration;
  public environment: string;

  private readonly lenderService = inject(LenderService);
  private readonly runtimeConfigService = inject(RuntimeConfigService);
  
  public ngOnInit(): void {
    this.lenderConfig = this.lenderService.lenderDataInfo;
    this.setEnvironment();
  }

  /**
   * Set the environment based on the DX API URL in runtime config service.
   */
  private setEnvironment(): void {
    const apiUrl = this.runtimeConfigService.getDXAPIBaseUrl();
    // Split the URL to extract the environment part
    const apiEnvPart = apiUrl?.split('.')[0].toString().toLowerCase();
    if (!apiEnvPart) {
      this.environment = undefined;
      return;
    }
    if(apiEnvPart.includes('dev')) {
      this.environment = 'dev';
    } else if(apiEnvPart.includes('qa')) {
      this.environment = 'qa';
    } else if(apiEnvPart.includes('uat')) {
      this.environment = 'uat';
    } else {
      this.environment = undefined;
    }
  }
}